<div class="log-cinematic-top-info">
    <avi-card class="log-cinematic-top-info__top-card">
        <avi-card_header class="log-cinematic-top-info__top-card-header">
            <cds-icon
                shape="switch"
                size="30"
                status="success"
            ></cds-icon>
            <span class="log-cinematic-top-info__top-card-header-text">
                {{ l10nKeys.endToEndTimingLabel | vtranslate }}
            </span>
        </avi-card_header>

        <avi-card_body class="log-cinematic-top-info__top-card-body">
            <ng-container *ngrxLet="vsAppProfileType$ as vsAppProfileType">
                <!-- L7 -->
                <ng-container *ngIf="vsAppProfileType === VsAppProfileType.L7">
                    <!--         Client -> Client RTT -> Security        -->
                    <log-cinematic-end-to-end-knot
                        headerText="{{ globalL10nKeys.clientLabel | vtranslate }}"
                        iconShape="user"
                    ></log-cinematic-end-to-end-knot>

                    <!-- Bridge  -->
                    <log-cinematic-end-to-end-bridge
                        class="log-cinematic-top-info__bridge log-cinematic-top-info__bridge--medium"
                        topHeader="{{ l10nKeys.clientRttLabel | vtranslate }}"
                        arrowColor="blue"
                        [endToEndTime]="clientRtt$ | async"
                        endToEndTimeFilterProp="client_rtt"
                        [statusCode]="responseCode$ | async"
                        statusCodeFilterProp="response_code"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    ></log-cinematic-end-to-end-bridge>

                    <log-cinematic-end-to-end-knot
                        *ngIf="hasWafPolicy$ | async"
                        class="log-cinematic-top-info__top-card-knot--security"
                        headerText="{{ globalL10nKeys.wafLabel | vtranslate }}"
                        topHeaderColor="blue"
                        iconShape="shield"
                        iconStatus="info"
                    ></log-cinematic-end-to-end-knot>

                    <!-- Load Balancer -->
                    <log-cinematic-end-to-end-knot
                        headerText="{{ globalL10nKeys.loadBalancerLabel | vtranslate }}"
                        iconShape="load-balancer"
                    ></log-cinematic-end-to-end-knot>

                    <!-- Bridge  -->
                    <log-cinematic-end-to-end-bridge
                        class="log-cinematic-top-info__bridge log-cinematic-top-info__bridge--medium"
                        topHeader="{{ l10nKeys.serverRttLabel | vtranslate }}"
                        arrowColor="green"
                        [endToEndTime]="serverRtt$ | async"
                        endToEndTimeFilterProp="server_rtt"
                        [statusCode]="serverResponseCode$ | async"
                        statusCodeFilterProp="server_response_code"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    ></log-cinematic-end-to-end-bridge>

                    <!--      Server -> App Response -> App       -->
                    <div class="log-cinematic-top-info__top-card-box-section log-cinematic-top-info__top-card-server-app-box">
                        <log-cinematic-end-to-end-knot
                            headerText="{{ globalL10nKeys.serverLabel | vtranslate }}"
                            iconShape="rack-server"
                        ></log-cinematic-end-to-end-knot>

                        <!-- Bridge  -->
                        <log-cinematic-end-to-end-bridge
                            class="log-cinematic-top-info__bridge log-cinematic-top-info__bridge--long"
                            topHeader="{{ l10nKeys.appResponseLabel | vtranslate }}"
                            arrowColor="yellow"
                            [endToEndTime]="appResponseTime$ | async"
                            endToEndTimeFilterProp="app_response_time"
                            [noStatusCode]="true"
                            (onFilterAdd)="logCinematicStore.closeCinematic()"
                        ></log-cinematic-end-to-end-bridge>

                        <log-cinematic-end-to-end-knot
                            headerText="{{ globalL10nKeys.appLabel | vtranslate }}"
                            iconShape="application"
                        ></log-cinematic-end-to-end-knot>
                    </div>

                    <!-- Data Transfer -->
                    <log-cinematic-end-to-end-bridge
                        class="log-cinematic-top-info__bridge"
                        topHeader="{{ l10nKeys.dataTransferLabel | vtranslate }}"
                        [endToEndTime]="dataTransferTime$ | async"
                        endToEndTimeFilterProp="data_transfer_time"
                        [noArrow]="true"
                        [noStatusCode]="true"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    ></log-cinematic-end-to-end-bridge>

                    <!-- Total Time -->
                    <log-cinematic-end-to-end-bridge
                        class="log-cinematic-top-info__bridge"
                        topHeader="{{ globalL10nKeys.totalTimeLabel | vtranslate }}"
                        [endToEndTime]="totalTime$ | async"
                        endToEndTimeFilterProp="total_time"
                        [noArrow]="true"
                        [noStatusCode]="true"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    ></log-cinematic-end-to-end-bridge>
                </ng-container>

                <!-- DNS -->
                <div
                    *ngIf="vsAppProfileType === VsAppProfileType.DNS"
                    class="log-cinematic-top-info__top-card-dns-end-to-end"
                >
                    <!-- Load Balancer -->
                    <log-cinematic-end-to-end-knot
                        headerText="{{ globalL10nKeys.loadBalancerLabel | vtranslate }}"
                        iconShape="load-balancer"
                    ></log-cinematic-end-to-end-knot>

                    <!-- Bridge  -->
                    <log-cinematic-end-to-end-bridge
                        class="log-cinematic-top-info__bridge log-cinematic-top-info__bridge--long"
                        topHeader="{{ l10nKeys.serverRttLabel | vtranslate }}"
                        arrowColor="green"
                        [endToEndTime]="serverRtt$ | async"
                        endToEndTimeFilterProp="server_rtt"
                        [noStatusCode]="true"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    ></log-cinematic-end-to-end-bridge>

                    <!-- DNS Server -->
                    <log-cinematic-end-to-end-knot
                        class="log-cinematic-top-info__top-card-box-section"
                        headerText="{{ l10nKeys.dnsServerLabel | vtranslate }}"
                        iconShape="rack-server"
                    ></log-cinematic-end-to-end-knot>
                </div>

                <!-- L4 -->
                <div
                    *ngIf="vsAppProfileType === VsAppProfileType.L4"
                    class="log-cinematic-top-info__top-card-l4-end-to-end"
                >
                    <!-- Client -->
                    <log-cinematic-end-to-end-knot
                        headerText="{{ globalL10nKeys.clientLabel | vtranslate }}"
                        iconShape="user"
                    ></log-cinematic-end-to-end-knot>

                    <!-- Bridge  -->
                    <log-cinematic-end-to-end-bridge
                        class="log-cinematic-top-info__bridge log-cinematic-top-info__bridge--long"
                        topHeader="{{ l10nKeys.clientRttLabel | vtranslate }}"
                        arrowColor="blue"
                        [endToEndTime]="clientRtt$ | async"
                        endToEndTimeFilterProp="client_rtt"
                        [noStatusCode]="true"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    ></log-cinematic-end-to-end-bridge>

                    <!-- Load Balancer -->
                    <log-cinematic-end-to-end-knot
                        headerText="{{ globalL10nKeys.loadBalancerLabel | vtranslate }}"
                        iconShape="load-balancer"
                    ></log-cinematic-end-to-end-knot>

                    <!-- Bridge  -->
                    <log-cinematic-end-to-end-bridge
                        class="log-cinematic-top-info__bridge log-cinematic-top-info__bridge--long"
                        topHeader="{{ l10nKeys.serverRttLabel | vtranslate }}"
                        arrowColor="green"
                        [endToEndTime]="serverRtt$ | async"
                        endToEndTimeFilterProp="server_rtt"
                        [noStatusCode]="true"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    ></log-cinematic-end-to-end-bridge>

                    <!-- Server -->
                    <log-cinematic-end-to-end-knot
                        class="log-cinematic-top-info__top-card-box-section"
                        headerText="{{ globalL10nKeys.serverLabel | vtranslate }}"
                        iconShape="rack-server"
                    ></log-cinematic-end-to-end-knot>

                    <!-- Total Time -->
                    <log-cinematic-end-to-end-bridge
                        class="log-cinematic-top-info__bridge"
                        topHeader="{{ globalL10nKeys.totalTimeLabel | vtranslate }}"
                        [endToEndTime]="totalTime$ | async"
                        endToEndTimeFilterProp="total_time"
                        [noArrow]="true"
                        [noStatusCode]="true"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    ></log-cinematic-end-to-end-bridge>
                </div>
            </ng-container>
        </avi-card_body>
    </avi-card>

    <!-- IP Section -->
    <div class="log-cinematic-top-info__communicating-ips">
    <!-- 1st row -->
        <!-- IP field titles -->
        <div class="log-cinematic-top-info__top-info-section-row">
            <div class="log-cinematic-top-info__top-info-section-row-col">
                <div logFieldTitle>
                    {{ globalL10nKeys.clientIpLabel | vtranslate }}
                </div>
                <double-arrow
                    class="log-cinematic-top-info__connection-arrow log-cinematic-top-info__bridge--long"
                    color="green"
                ></double-arrow>
            </div>
            <div class="log-cinematic-top-info__top-info-section-row-col">
                <div logFieldTitle>
                    {{ l10nKeys.virtualServiceIpLabel | vtranslate }}
                </div>
            </div>
            <div class="log-cinematic-top-info__top-info-section-row-col">
                <!-- intentionally left blank as a placeholder -->
            </div>
        </div>

        <!-- IP data -->
        <div class="log-cinematic-top-info__top-info-section-row">
            <!-- Client IP -->
            <div class="log-cinematic-top-info__top-info-section-row-col">
                <ng-container *ngrxLet="clientIps$ as clientIps">
                    <ng-container *ngIf="clientIps.client_ip || clientIps.client_ip6; else noData">
                        <log-cinematic-ip-field
                            *ngIf="clientIps.client_ip && !clientIps.client_ip6"
                            property="client_ip"
                            [ip]="clientIps.client_ip"
                            portProperty="client_src_port"
                            [port]="clientSrcPort$ | async"
                        ></log-cinematic-ip-field>

                        <log-cinematic-ip-field
                            *ngIf="clientIps.client_ip6"
                            version="ipv6"
                            property="client_ip6"
                            [ip]="clientIps.client_ip6"
                            portProperty="client_src_port"
                            [port]="clientSrcPort$ | async"
                        ></log-cinematic-ip-field>
                    </ng-container>
                </ng-container>
            </div>

            <!-- VS IP -->
            <div class="log-cinematic-top-info__top-info-section-row-col">
                <ng-container *ngrxLet="vsIps$ as vsIps">
                    <ng-container *ngIf="vsIps.vs_ip || vsIps.vs_ip6">
                        <log-cinematic-ip-field
                            *ngIf="vsIps.vs_ip && !vsIps.vs_ip6"
                            property="vs_ip"
                            [ip]="vsIps.vs_ip"
                            portProperty="client_dest_port"
                            [port]="clientDestPort$ | async"
                        ></log-cinematic-ip-field>
                        <log-cinematic-ip-field
                            *ngIf="vsIps.vs_ip6"
                            version="ipv6"
                            property="vs_ip6"
                            [ip]="vsIps.vs_ip6"
                            portProperty="client_dest_port"
                            [port]="clientDestPort$ | async"
                        ></log-cinematic-ip-field>
                    </ng-container>
                    <span *ngIf="!vsIps.vs_ip && !vsIps.vs_ip6">
                        <!-- no filter here -->
                        {{ defaultVsIp$ | async }}
                    </span>
                </ng-container>
            </div>

            <div class="log-cinematic-top-info__top-info-section-row-col">
                <!-- intentionally left blank as a placeholder -->
            </div>
        </div>

        <!-- 2nd row -->
        <ng-container *ngrxLet="vsAppProfileType$ as vsAppProfileType">
            <ng-container *ngrxLet="pool$ as hasPool">
                <!-- IP field titles -->
                <div class="log-cinematic-top-info__top-info-section-row">
                    <div class="log-cinematic-top-info__top-info-section-row-col">
                        <div
                            logFieldTitle
                            *ngIf="vsAppProfileType === VsAppProfileType.L7"
                        >
                            {{ l10nKeys.sourceClientIpLabel | vtranslate }}
                        </div>
                    </div>
                    <div class="log-cinematic-top-info__top-info-section-row-col">
                        <ng-container *ngIf="vsAppProfileType !== VsAppProfileType.DNS || hasPool">
                            <div logFieldTitle>
                                {{ l10nKeys.serverConnectionIpLabel | vtranslate }}
                            </div>
                            <double-arrow
                                class="log-cinematic-top-info__connection-arrow log-cinematic-top-info__bridge--long"
                                color="green"
                            ></double-arrow>
                        </ng-container>
                    </div>
                    <div class="log-cinematic-top-info__top-info-section-row-col">
                        <div
                            logFieldTitle
                            *ngIf="vsAppProfileType !== VsAppProfileType.DNS || hasPool"
                        >
                            {{ globalL10nKeys.serverIpLabel | vtranslate }}
                        </div>
                    </div>
                </div>

                <!-- IP data -->
                <div class="log-cinematic-top-info__top-info-section-row">
                    <!-- Source Client IP -->
                    <div class="log-cinematic-top-info__top-info-section-row-col">
                        <ng-container *ngIf="vsAppProfileType === VsAppProfileType.L7">
                            <ng-container *ngrxLet="sourceIps$ as sourceIps">
                                <ng-container *ngIf="sourceIps.source_ip || sourceIps.source_ip6; else noData">
                                    <log-cinematic-ip-field
                                        *ngIf="sourceIps.source_ip && !sourceIps.source_ip6"
                                        property="source_ip"
                                        [ip]="sourceIps.source_ip"
                                    ></log-cinematic-ip-field>
                                    <log-cinematic-ip-field
                                        *ngIf="sourceIps.source_ip6"
                                        version="ipv6"
                                        property="source_ip6"
                                        [ip]="sourceIps.source_ip6"
                                    ></log-cinematic-ip-field>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>

                    <!-- Server Connection IP -->
                    <div class="log-cinematic-top-info__top-info-section-row-col">
                        <ng-container *ngIf="vsAppProfileType !== VsAppProfileType.DNS || hasPool">
                            <ng-container *ngrxLet="serverConnectionSrcIps$ as serverConnSrcIps">
                                <ng-container *ngIf="serverConnSrcIps.server_conn_src_ip || serverConnSrcIps.server_conn_src_ip6; else noData">
                                    <log-cinematic-ip-field
                                        *ngIf="serverConnSrcIps.server_conn_src_ip && !serverConnSrcIps.server_conn_src_ip6"
                                        property="server_conn_src_ip"
                                        [ip]="serverConnSrcIps.server_conn_src_ip"
                                        portProperty="server_src_port"
                                        [port]="serverSrcPort$ | async"
                                    ></log-cinematic-ip-field>
                                    <log-cinematic-ip-field
                                        *ngIf="serverConnSrcIps.server_conn_src_ip6 as ip6"
                                        version="ipv6"
                                        property="server_conn_src_ip6"
                                        [ip]="ip6"
                                        portProperty="server_src_port"
                                        [port]="serverSrcPort$ | async"
                                    ></log-cinematic-ip-field>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>

                    <!-- Server IP -->
                    <div class="log-cinematic-top-info__top-info-section-row-col">
                        <ng-container *ngIf="vsAppProfileType !== VsAppProfileType.DNS || hasPool">
                            <ng-container *ngrxLet="serverIps$ as serverIps">
                                <span
                                    *ngIf="(poolName$ | async) as poolName"
                                    logPartialSelectionFilter
                                    property="pool_name"
                                    [value]="poolName"
                                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                                ></span>
                                <ng-container *ngrxLet="serverName$ as serverName">
                                    <ng-container *ngIf="serverName && serverName !== (serverIps.server_ip | toString)">
                                        :<span
                                            logPartialSelectionFilter
                                            property="server_name"
                                            [value]="serverName"
                                            [noSearchIcon]="true"
                                            (onFilterAdd)="logCinematicStore.closeCinematic()"
                                        ></span>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="serverIps.server_ip || serverIps.server_ip6 else noData">
                                    (<log-cinematic-ip-field
                                            *ngIf="serverIps.server_ip && !serverIps.server_ip6"
                                            property="server_ip"
                                            [ip]="serverIps.server_ip"
                                            portProperty="server_dest_port"
                                            [port]="serverDestPort$ | async"
                                            [noIpSearchIcon]="true"
                                        ></log-cinematic-ip-field>
                                        <log-cinematic-ip-field
                                            *ngIf="serverIps.server_ip6 as ip6"
                                            version="ipv6"
                                            property="server_ip6"
                                            [ip]="ip6"
                                            portProperty="server_dest_port"
                                            [port]="serverDestPort$ | async"
                                            [noIpSearchIcon]="true"
                                        ></log-cinematic-ip-field>)
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <!-- 3rd row -->
        <!-- IP field titles -->
        <div class="log-cinematic-top-info__top-info-section-row">
            <div class="log-cinematic-top-info__top-info-section-row-col">
                <!-- intentionally left blank as a placeholder -->
            </div>
            <div class="log-cinematic-top-info__top-info-section-row-col">
                <div logFieldTitle>
                    {{ globalL10nKeys.serviceEngineLabel | vtranslate }}
                </div>
                <div class="log-cinematic-top-info__top-info-section-row-col">
                    <!-- intentionally left blank as a placeholder -->
                </div>
            </div>
            <div class="log-cinematic-top-info__top-info-section-row-col">
                <!-- intentionally left blank as a placeholder -->
            </div>
        </div>

        <!-- IP data -->
        <div class="log-cinematic-top-info__top-info-section-row">
            <div class="log-cinematic-top-info__top-info-section-row-col">
                <!-- intentionally left blank as a placeholder -->
            </div>

            <!-- Service Engine -->
            <div class="log-cinematic-top-info__top-info-section-row-col">
                <div
                    *ngrxLet="serviceEngine$ as serviceEngine"
                    logPartialSelectionFilter
                    property="service_engine"
                    [value]="serviceEngine"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                ></div>
                &nbsp;(vcpu:
                <span
                    *ngrxLet="vcpuId$ as vcpuId"
                    logFilter
                    property="vcpu_id"
                    [value]="vcpuId"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ vcpuId }}
                </span>)
            </div>

            <div class="log-cinematic-top-info__top-info-section-row-col">
                <!-- intentionally left blank as a placeholder -->
            </div>
        </div>
    </div>
</div>

<ng-template #noData>
    <span logEmptyField></span>
</ng-template>
